module.exports = __webpack_public_path__ + "img/helicopter.1bc1e9bf.jpg";